import {
  CARD_VIEW,
  HEADER_COMPONENT,
  LEAD_TYPES,
  THANK_YOU_VIEWS,
} from 'site-modules/shared/constants/lead-form/lead-form-params';

export const getBuildPriceCustomConfig = ({
  creativeId,
  srpLink,
  headerText,
  processDataMethods,
  bestDealPrice,
  isMobile,
}) => ({
  leadType: LEAD_TYPES.ANY,
  creativeId,
  processDataMethods,
  leadFormConfig: {
    cardView: CARD_VIEW.DEALER_SIMPLE,
    submitButtonText: 'Get Dealer Offers',
    preSelectedCardNumbers: 3,
    userInfoPosition: isMobile ? 1 : undefined,
    withFormClasses: false,
    hideWhenLeadTargetsEmpty: true,
    headerConfig: {
      headerComponent: HEADER_COMPONENT.EMBEDDED,
      header: {
        tag: 'h2',
        showLogo: false,
        srpLink: {
          to: srpLink,
          text: 'See all for sale',
        },
        text: headerText || 'Take the next step! Get dealer offers',
        explainingText:
          "{savingsValue=0?:You can save up to {savingsValue} with Edmunds!} When you send requests for price quotes from multiple dealers, you effectively make them compete for your business. It's also much more convenient to shop from the comfort of your home.",
      },
    },
  },
  thankYouComponent: THANK_YOU_VIEWS.TRANSPARENT_PRICING_PRICE_CHECKER,
  thankYouConfig: {
    className: 'px-0',
    withFormClasses: false,
    headerConfig: {
      headerComponent: HEADER_COMPONENT.PRICE_CHECKER,
      header: {
        text: 'Smart move!',
        explainingText: 'You’re on your way to savings. Here’s what to do next:',
        showSeparator: 'false',
      },
    },
    adsConfig: { adComponent: null },
    priceCheckerParams: { bestDealPrice },
    isBuildPriceAdEnabled: true,
  },
});
